<template>
  <section>
    <h3>Sobre mim</h3>
    <p>
      Sou Anelise Chagas, psicóloga formada pela UNOESC - Campus São Miguel do Oeste,
      onde desenvolvi uma sólida formação teórica e prática em Psicologia.
      Trabalho com a Abordagem Centrada na Pessoa (ACP), priorizando empatia,
      acolhimento e aceitação incondicional.
    </p>

    <p>
      Ofereço um espaço seguro e acolhedor para adolescentes, adultos e idosos
      explorarem suas emoções e fortalecerem seu bem-estar emocional.
    </p>
  </section>
</template>

<style scoped>
h3 {
  font-size: 1.8rem;
  margin-bottom: 10px;
  color: #2c5e6e;
}
p {
  line-height: 1.7;
  margin-bottom: 20px;
}
</style>
